var _rect, _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyNzd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136728)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#012169"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136728)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9791 -0.448242H-10.6055V21.844H33.9791V-0.448242Z",
    fill: "#012169"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1516_136728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -11,
    y: -1,
    width: 23,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-10.6016 -0.448242H11.6907V10.6979H-10.6016V-0.448242Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1516_136728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.6016 -0.448242L11.6907 10.6979ZM-10.6016 10.6979L11.6907 -0.448242Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.6016 -0.448242L11.6907 10.6979M-10.6016 10.6979L11.6907 -0.448242",
    stroke: "white",
    strokeWidth: 2.22923
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1516_136728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -11,
    y: -1,
    width: 23,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-10.6016 -0.448242L0.544578 5.12483H-10.6016V-0.448242ZM0.544578 -0.448242H11.6907L0.544578 5.12483V-0.448242ZM0.544578 5.12483H11.6907V10.6979L0.544578 5.12483ZM0.544578 5.12483V10.6979H-10.6016L0.544578 5.12483Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1516_136728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.6016 -0.448242L11.6907 10.6979ZM-10.6016 10.6979L11.6907 -0.448242Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.6016 -0.448242L11.6907 10.6979M-10.6016 10.6979L11.6907 -0.448242",
    stroke: "#C8102E",
    strokeWidth: 1.48615
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1516_136728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -11,
    y: -1,
    width: 23,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-10.6016 -0.448242H11.6907V10.6979H-10.6016V-0.448242Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1516_136728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.544578 -0.448242V10.6979ZM-10.6016 5.12483H11.6907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.544578 -0.448242V10.6979M-10.6016 5.12483H11.6907",
    stroke: "white",
    strokeWidth: 3.71538
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1516_136728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -11,
    y: -1,
    width: 23,
    height: 12
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-10.6016 -0.448242H11.6907V10.6979H-10.6016V-0.448242Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1516_136728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.544578 -0.448242V10.6979ZM-10.6016 5.12483H11.6907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.544578 -0.448242V10.6979M-10.6016 5.12483H11.6907",
    stroke: "#C8102E",
    strokeWidth: 2.22923
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.832 3.46338V4.30677L24.5188 3.46338H22.832Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.152 4.45478L22.6562 3.77246L24.5166 3.46331L23.152 4.45478Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8281 3.46338V4.30677L21.1413 3.46338H22.8281Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5082 4.45478L23.0039 3.77246L21.1435 3.46331L22.5082 4.45478Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3477 3.8418L22.5455 4.10242L23.8689 5.44602L23.3477 3.8418Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5082 4.45429L23.0039 3.77197L23.8728 5.44576L22.5082 4.45429Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3086 3.84131L23.1107 4.10193L22.8298 2.23708L22.3086 3.84131Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3451 3.84143L22.543 4.10205L22.8238 2.2372L23.3451 3.84143Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3086 3.8418L23.1107 4.10242L21.7873 5.44602L22.3086 3.8418Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1481 4.45429L22.6523 3.77197L21.7834 5.44576L23.1481 4.45429Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.832 3.64893V4.20623L23.9466 3.64893H22.832Z",
    fill: "#C8102E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0424 4.30439L22.7148 3.85352L23.9442 3.64923L23.0424 4.30439Z",
    fill: "#C8102E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8359 3.64893V4.20623L21.7213 3.64893H22.8359Z",
    fill: "#C8102E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 4.30439L22.9492 3.85352L21.7199 3.64923L22.6216 4.30439Z",
    fill: "#C8102E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1758 3.89941L22.6458 4.07163L23.5202 4.95948L23.1758 3.89941Z",
    fill: "#C8102E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6177 4.3039L22.9453 3.85303L23.5195 4.95905L22.6177 4.3039Z",
    fill: "#C8102E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4844 3.89893L23.0144 4.07114L22.8288 2.83886L22.4844 3.89893Z",
    fill: "#C8102E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1746 3.89907L22.6445 4.07129L22.8301 2.83901L23.1746 3.89907Z",
    fill: "#C8102E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4883 3.89941L23.0183 4.07163L22.1438 4.95948L22.4883 3.89941Z",
    fill: "#C8102E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0463 4.30439L22.7188 3.85352L22.1446 4.95954L23.0463 4.30439Z",
    fill: "#C8102E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2539 7.36084L27.2539 8.11135L28.7549 7.36084L27.2539 7.36084Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5388 8.2434L27.0977 7.63623L28.7531 7.36113L27.5388 8.2434Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 7.36084L27.25 8.11135L25.749 7.36084L27.25 7.36084Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9651 8.2434L27.4062 7.63623L25.7508 7.36113L26.9651 8.2434Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7188 7.69775L27.005 7.92967L28.1826 9.1253L27.7188 7.69775Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9651 8.24243L27.4062 7.63525L28.1795 9.1247L26.9651 8.24243Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.793 7.69775L27.5067 7.92967L27.2568 6.2702L26.793 7.69775Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7216 7.69728L27.0078 7.9292L27.2577 6.26973L27.7216 7.69728Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26.793 7.69775L27.5067 7.92967L26.3291 9.1253L26.793 7.69775Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5466 8.24243L27.1055 7.63525L26.3323 9.1247L27.5466 8.24243Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2539 7.54639L27.2539 8.01081L28.1828 7.54639L27.2539 7.54639Z",
    fill: "#C8102E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4292 8.09252L27.1562 7.7168L28.1807 7.54656L27.4292 8.09252Z",
    fill: "#C8102E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 7.54639L27.25 8.01081L26.3212 7.54639L27.25 7.54639Z",
    fill: "#C8102E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0747 8.09252L27.3477 7.7168L26.3232 7.54656L27.0747 8.09252Z",
    fill: "#C8102E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5391 7.75537L27.0974 7.89889L27.8261 8.63876L27.5391 7.75537Z",
    fill: "#C8102E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0747 8.09301L27.3477 7.71729L27.8261 8.63897L27.0747 8.09301Z",
    fill: "#C8102E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9609 7.75537L27.4026 7.89889L27.248 6.87199L26.9609 7.75537Z",
    fill: "#C8102E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5354 7.75541L27.0938 7.89893L27.2484 6.87203L27.5354 7.75541Z",
    fill: "#C8102E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9609 7.75537L27.4026 7.89889L26.6739 8.63876L26.9609 7.75537Z",
    fill: "#C8102E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4253 8.09301L27.1523 7.71729L26.6739 8.63897L27.4253 8.09301Z",
    fill: "#C8102E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6875 8.64551L17.6875 9.4889L19.3743 8.64551L17.6875 8.64551Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0075 9.63691L17.5117 8.95459L19.3721 8.64544L18.0075 9.63691Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6836 8.64551L17.6836 9.4889L15.9968 8.64551L17.6836 8.64551Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3636 9.63691L17.8594 8.95459L15.999 8.64544L17.3636 9.63691Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2109 9.02393L17.4088 9.28455L18.7322 10.6282L18.2109 9.02393Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3715 9.63642L17.8672 8.9541L18.7361 10.6279L17.3715 9.63642Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1602 9.02393L17.9623 9.28455L17.6814 7.4197L17.1602 9.02393Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2006 9.02405L17.3984 9.28467L17.6793 7.41982L18.2006 9.02405Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1641 9.02393L17.9662 9.28455L16.6428 10.6282L17.1641 9.02393Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0035 9.63642L17.5078 8.9541L16.6389 10.6279L18.0035 9.63642Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6797 8.83057L17.6797 9.38787L18.7943 8.83057L17.6797 8.83057Z",
    fill: "#C8102E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M17.894 9.48603L17.5664 9.03516L18.7957 8.83087L17.894 9.48603Z",
    fill: "#C8102E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6875 8.83057L17.6875 9.38787L16.5729 8.83057L17.6875 8.83057Z",
    fill: "#C8102E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4732 9.48603L17.8008 9.03516L16.5715 8.83087L17.4732 9.48603Z",
    fill: "#C8102E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0273 9.08154L17.4973 9.25376L18.3718 10.1416L18.0273 9.08154Z",
    fill: "#C8102E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4693 9.48652L17.7969 9.03564L18.371 10.1417L17.4693 9.48652Z",
    fill: "#C8102E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3359 9.08057L17.866 9.25278L17.6804 8.02051L17.3359 9.08057Z",
    fill: "#C8102E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0261 9.08071L17.4961 9.25293L17.6817 8.02065L18.0261 9.08071Z",
    fill: "#C8102E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3398 9.08105L17.8699 9.25327L16.9954 10.1411L17.3398 9.08105Z",
    fill: "#C8102E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8979 9.48603L17.5703 9.03516L16.9961 10.1412L17.8979 9.48603Z",
    fill: "#C8102E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8281 16.7778V17.7141L24.7007 16.7778H22.8281Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M23.187 17.8781L22.6367 17.1206L24.702 16.7774L23.187 17.8781Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M22.832 16.7778V17.7141L20.9595 16.7778H22.832Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M22.477 17.8781L23.0273 17.1206L20.9621 16.7774L22.477 17.8781Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4141 17.1982L22.5236 17.4876L23.9927 18.9791L23.4141 17.1982Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M22.477 17.8786L23.0273 17.1211L23.9919 18.9792L22.477 17.8786Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2539 17.1987L23.1444 17.4881L22.8326 15.4178L22.2539 17.1987Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4139 17.199L22.5234 17.4883L22.8352 15.4181L23.4139 17.199Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 17.1982L23.1405 17.4876L21.6713 18.9791L22.25 17.1982Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M23.187 17.8786L22.6367 17.1211L21.6721 18.9792L23.187 17.8786Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M22.832 16.9639V17.6141L24.1324 16.9639H22.832Z",
    fill: "#C8102E"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0814 17.7282L22.6992 17.2021L24.1334 16.9638L23.0814 17.7282Z",
    fill: "#C8102E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M22.832 16.9639V17.6141L21.5316 16.9639H22.832Z",
    fill: "#C8102E"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5827 17.7282L22.9648 17.2021L21.5306 16.9638L22.5827 17.7282Z",
    fill: "#C8102E"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2344 17.2559L22.616 17.4568L23.6362 18.4926L23.2344 17.2559Z",
    fill: "#C8102E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5827 17.7287L22.9648 17.2026L23.6347 18.493L22.5827 17.7287Z",
    fill: "#C8102E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4336 17.2559L23.052 17.4568L22.8354 16.0191L22.4336 17.2559Z",
    fill: "#C8102E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2395 17.2556L22.6211 17.4565L22.8376 16.0189L23.2395 17.2556Z",
    fill: "#C8102E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4297 17.2559L23.0481 17.4568L22.0278 18.4926L22.4297 17.2559Z",
    fill: "#C8102E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0814 17.7287L22.6992 17.2026L22.0294 18.493L23.0814 17.7287Z",
    fill: "#C8102E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.8857,
    height: 21.209,
    fill: "white",
    transform: "translate(-2.88672 0.734863)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyNzd);
export default __webpack_public_path__ + "static/media/Currency=NZD.3a84c3a092287861669eb798b0b77f29.svg";
export { ForwardRef as ReactComponent };